import { useState } from 'react';
import PropTypes from 'prop-types';
import { useAsyncDebounce } from 'react-table';
import useTranslation from 'next-translate/useTranslation';

// Components
import Icon from '@/components/base/Icon';
import Input from '@/components/base/Input';

const InputSearch = ({ setRequestParams }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const onChange = useAsyncDebounce((value) => {
        setRequestParams((prevState) => ({
            ...prevState,
            page: 1,
            filter_name: value !== '' ? value : undefined
        }));
    }, 400);

    return (
        <div className="flex grow items-baseline" data-testid="input-search-filter">
            <Input
                noBorder
                noBorderShadow
                id="search"
                type="text"
                autoComplete="off"
                placeholder={t('reports:general.search_placeholder')}
                beforeInput={<Icon icon="search" />}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
            />
        </div>
    );
};

InputSearch.propTypes = {
    setRequestParams: PropTypes.func
};

export default InputSearch;
